module.exports = __webpack_public_path__ + "img/logo.474da3fa.png";